import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import DetailInfo from "Components/UI/DetailInfo/DetailInfo";
import { format } from "Shared/Utils/shared";
import { FORMAT_FULL_DATE } from "Shared/Constants/app";
import { getNestedProperty } from "Shared/Utils/getNestedProperty";
import {
  clearCurrentVehicleAssignmentDetail,
  selectDashboardVehicleAssignmentDetail,
  selectDashboardVehicleAssignmentDetailLoading,
} from "Redux/Dashboard/slice";
import { AssignmentDetail } from "Shared/Types/fleetmanagementapi";
import { Loader } from "Components/UI/Loader";
import loaderStyles from "Components/Layout/Layout.module.scss";
import { getRoutWithId } from "Shared/Constants/routeIdenicator";
import { UNITS } from "Shared/Constants/routes";
import { dashboardVehicleAssignmentDetailInfo } from "Shared/Constants/dashboard";
import { useAppDispatch } from "Redux/store";

import styles from "./VehicleAssignment.module.scss";

type AssignmentDetailProps = {
  closeModal: () => void;
  setAssignmentId: (id: string | null) => void;
};

const VehicleAssignmentDetail: FC<AssignmentDetailProps> = ({
  closeModal,
  setAssignmentId,
}) => {
  const currentDashboardVehicleAssignment = useSelector(
    selectDashboardVehicleAssignmentDetail,
  );
  const navigate = useNavigate();
  const loading = useSelector(selectDashboardVehicleAssignmentDetailLoading);
  const dispatch = useAppDispatch();

  const renderRow = (value: any, key: string) => {
    if (key === "vehicle") {
      return (
        currentDashboardVehicleAssignment?.vehicle && (
          <span
            className={styles.rowCell_blue}
            onClick={(e) => {
              e.stopPropagation();
              navigate(
                getRoutWithId(
                  UNITS,
                  currentDashboardVehicleAssignment?.vehicle.id,
                ),
              );
            }}
          >
            {currentDashboardVehicleAssignment?.vehicle.name || "---"}
          </span>
        )
      );
    }
    if (key === "start_datetime" || key === "end_datetime") {
      return format(value as string, FORMAT_FULL_DATE);
    }
    if (
      currentDashboardVehicleAssignment?.end_odometer &&
      currentDashboardVehicleAssignment?.start_odometer
    ) {
      return (
        +currentDashboardVehicleAssignment?.end_odometer -
        +currentDashboardVehicleAssignment?.start_odometer
      );
    }
    return (
      currentDashboardVehicleAssignment &&
      getNestedProperty<AssignmentDetail>(
        currentDashboardVehicleAssignment,
        key,
      )
    );
  };

  useEffect(() => {
    return () => {
      dispatch(clearCurrentVehicleAssignmentDetail());
      setAssignmentId(null);
    };
  }, []);

  return (
    <div>
      {loading ? (
        <div className={loaderStyles.loader}>
          <Loader size={50} />
        </div>
      ) : (
        currentDashboardVehicleAssignment && (
          <DetailInfo<AssignmentDetail>
            title="Assignment"
            renderRow={renderRow}
            data={currentDashboardVehicleAssignment}
            rows={dashboardVehicleAssignmentDetailInfo}
            onClose={closeModal}
            withoutMaxMinWith
            isStatic
          />
        )
      )}
    </div>
  );
};

export default VehicleAssignmentDetail;
